import {
    apiRequest,
    AcTeknisList
} from "../../../../../services/adapters/Assesment/assesmentService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", AcTeknisList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default DataTableRepository